module.exports = __webpack_public_path__ + "img/china.fd9aabd6.png";